import { useRef } from 'react';
import { motion, useScroll } from 'framer-motion';
import { MediaView } from './MediaView';
import { useLayerY } from '../../hooks/useParallax';
import type { Media } from '../../core/types/media';
type Props = {
  media: Media;
  /** Vorm en maat van het kader (bijv. `aspect-[4/5] w-full`). Het kader zelf staat stil. */
  className?: string;
  sizes?: string;
  /** Uitslag in px over de hele doorgang door het scherm. Telefoon: de helft; "minder beweging": niets. */
  range?: number;
  /** Bovenaan de pagina: met voorrang laden (zoals `MediaView priority`). */
  priority?: boolean;
};

/**
 * Een groot beeld dat binnen zijn vaste kader iets trager beweegt dan de pagina, als een raam
 * waar je langs loopt. De gedeelde diepte van de site (Over, Salon, Journal, Artikel). Het beeld
 * is iets hoger dan het kader, dus er komt nooit een rand in beeld.
 */
export function ParallaxMedia({
  media,
  className = '',
  sizes,
  range = 32,
  priority = false
}: Props) {
  const ref = useRef<HTMLDivElement>(null);
  const {
    scrollYProgress
  } = useScroll({
    target: ref,
    offset: ['start end', 'end start']
  });
  const y = useLayerY(scrollYProgress, [-range, range]);
  return <div ref={ref} className={`relative overflow-hidden ${className}`} data-id="element-8951" data-mp="9n3uhwphheo6">
      <motion.div style={y ? {
      y
    } : undefined} className="absolute inset-x-0 -inset-y-[6%]" data-id="element-8952" data-mp="ohi9lm5xg3xk">
        <MediaView media={media} sizes={sizes} priority={priority} className="h-full w-full" data-id="element-8953" data-mp="jjgnesd7fohv" />
      </motion.div>
    </div>;
}